import classNames from 'classnames';
import { FC } from 'react';
import React from 'react';

interface IHighlightedTextProps {
  text: string;
  highlight: string;
  spanClassName?: string;
  className?: string;
  id?: string;
}

const HighlightedText: FC<IHighlightedTextProps> = ({
  text = '',
  highlight = '',
  id = '',
  className,
  spanClassName,
}): React.JSX.Element => {
  const safeText = text || '';
  const safeHighlight = highlight || '';
  if (!safeHighlight) {
    return (
      <span className={classNames('inline-block w-full', spanClassName)} id={id}>
        {safeText}
      </span>
    );
  }
  return (
    <span className={classNames('inline-block w-full', spanClassName)} id={id}>
      {safeText.split(safeHighlight).map((part, index, arr) => (
        <React.Fragment key={index}>
          {part}
          {index < arr.length - 1 && <span className={className}>{safeHighlight}</span>}
        </React.Fragment>
      ))}
    </span>
  );
};

export default HighlightedText;
